// extracted by mini-css-extract-plugin
module.exports = {"empty-space-behind-nav":"empty-space-behind-nav__B_MVC","sticky-nav":"sticky-nav__3suW_","sticky-button-mode--invisible":"sticky-button-mode--invisible__S8uzb"};